import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';

export interface IProofSubject {
  id: string;
  name: string;
  questions: string[];
}

interface IParams {
  selective_process_id: string;
  registration_id?: string;
}

const candidatefSubjects = async (params: IParams) => {
  if (!params.selective_process_id) return;

  const response = await configApi.get<IProofSubject[]>('candidate-area/subjects/candidate/', {
    params: {
      selective_process: params.selective_process_id,
      registration_id: params.registration_id,
    },
  });

  return response.data;
};

export const useCandidatefSubjects = (params: IParams) => {
  return useQuery({
    queryKey: ['candidate_subjects', params?.selective_process_id, params?.registration_id],
    queryFn: () => candidatefSubjects(params),
    enabled: !!params.selective_process_id && !!params.registration_id,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
